// Event tickets are Shopify products tagged `ticket` (backend/lib/ticketProducts.js
// holds the authoritative check). An order of only tickets needs no recipient,
// card message or delivery/pickup details.

export const isTicketItem = (item) =>
  !!item?.isProduct &&
  (item.tags || []).some((tag) => String(tag).trim().toLowerCase() === 'ticket');

export const isTicketOnlyOrder = (items) =>
  Array.isArray(items) && items.length > 0 && items.every(isTicketItem);

// Seats left for a ticket variant, or null when we have no live count for it.
export const seatsLeft = (variant) =>
  variant && variant.liveInventory && variant.inventoryTracked !== false
    ? variant.inventoryQuantity
    : null;
